

















































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { DocProgettoOrientamento } from "../../_models/docProgettoOrientamento";
import { bus } from "../../main";
import * as user from "../../_store/user.module";

@Component
export default class ProgettoOrientamentoTirEstivoSign extends Vue {
  @Prop() docInfo!: DocProgettoOrientamento;
  @Prop() soggetto!: string;
  private firmaAzienda: string;

  constructor() {
    super();
    this.firmaAzienda = "";
  }

  clearEnterpriseSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignaturePad.clearSignature();
  }

  clearStudentSignature() {
    //@ts-ignore
    this.$refs.studentSignaturePad.clearSignature();
  }
  clearEnterpriseDueSignature() {
    //@ts-ignore
    this.$refs.enterpriseSignatureDuePad.clearSignature();
  }

  clearStudentDueSignature() {
    //@ts-ignore
    this.$refs.studentSignatureDuePad.clearSignature();
  }

  close() {
    bus.$emit("closeDocSignDialog");
  }

  save() {
    var signatureAziendaEmpty: boolean = true;
    var signatureAllievoEmpty: boolean = true;
    if (this.soggetto === "azienda") {
      //@ts-ignore
      const signatureAzienda = this.$refs.enterpriseSignaturePad.saveSignature();
      //@ts-ignore
      const signatureAziendaDue = this.$refs.enterpriseSignatureDuePad.saveSignature();
      if (signatureAzienda.isEmpty === false && signatureAziendaDue.isEmpty === false) {
        const payload = {
          idProgettoOrientamento: this.docInfo.idProgettoOrientamento,
          firma: signatureAzienda.data,
          firmaDue: signatureAziendaDue.data,
          soggetto: this.soggetto
        };
        user
          .dispatchSignProgettoOrientamento(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Progetto di Orientamento Firmato con successo"
            );
            bus.$emit("loadProgettoOrientamento");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      } else {
        bus.$emit("errorOperation", "Firma Legale Rappresentante mancante");
      }
    } else {
      //@ts-ignore
      const signatureAllievo = this.$refs.studentSignaturePad.saveSignature();
      //@ts-ignore
      const signatureAllievoDue = this.$refs.studentSignatureDuePad.saveSignature();
      if (signatureAllievo.isEmpty === false && signatureAllievoDue.isEmpty === false) {
        const payload = {
          idProgettoOrientamento: this.docInfo.idProgettoOrientamento,
          firma: signatureAllievo.data,
          firmaDue: signatureAllievoDue.data,
          soggetto: this.soggetto
        };
        user
          .dispatchSignProgettoOrientamento(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Progetto di Orientamento Firmato con successo"
            );
            bus.$emit("loadProgettoOrientamento");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      } else {
        bus.$emit("errorOperation", "Firma Tirocinante mancante");
      }
    }

    //dispatchSignProgettoOrientamento
  }
}
